import type { App } from "vue";
import {
  TemplateDataSourceImpl,
  templateDataSourceKey,
} from "./data/datasources/template_datasource";

export function initTemplateModule(app: App) {
  app.provide(templateDataSourceKey, new TemplateDataSourceImpl());
}
